import React, { FC } from 'react';

import {
  Dialog, Typography, Box,
} from '@material-ui/core';
import PricesheetBasicEditor from './PricesheetBasicsEditor';

interface AddPricesheetDialogProps {
  open: boolean;
  onSubmit: (value: any) => void;
}

const AddPricesheetDialog: FC<AddPricesheetDialogProps> = (props) => {
  const { onSubmit, open } = props;

  return (
    <Dialog aria-labelledby="simple-dialog-title" open={open}>
      <Typography variant="h3" style={{ padding: '1rem' }}>Create new pricesheet</Typography>
      <Box style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>
        <PricesheetBasicEditor
          buttonText="Create Pricesheet"
          onSubmit={onSubmit}
        />
      </Box>
      <Box style={{ padding: '1rem' }} />
    </Dialog>
  );
};

export default AddPricesheetDialog;
